//удаление классов по маске
global.jQuery.fn.removeClassWild = function (mask) {
	return this.removeClass(function (index, cls) {
		const re = new RegExp(String(`(${mask}.*?(\\s|$))`), 'g');
		return (cls.match(re) || []).join(' ');
	});
};



// WEBPACK FOOTER //
// ./temp/components/core/.variant/base/additionals/removeClassWild.js